<!-- Main Content -->
<div data-testid="order-audit-page" class="p-6 flex-table-page">
  <!-- Audit Type Tabs -->
  <h2 class="text-2xl font-semibold text-gray-800 mb-3 flex-table-header">
    {{ "order.audit.title" | translate }}
  </h2>
  <div class="flex mb-3 flex-table-header">
    @for (tab of auditTabs; track tab.value; let i = $index) {
      <button
        [attr.data-testid]="'order-audit-tab-' + tab.value + '-btn'"
        type="button"
        [class]="
          'px-4 py-2 text-sm font-medium border-b-2 ' +
          (activeTab === tab.value
            ? 'border-blue-500 text-blue-600'
            : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300')
        "
        (click)="onTabChange({ index: i })"
      >
        {{ tab.label | translate }}
      </button>
    }
  </div>

  <!-- Search Form -->
  <app-search-form
    data-testid="order-audit-search-form"
    [orderSources]="orderSources"
    [salesChannels]="salesChannels"
    [buyerNotesOptions]="buyerNotesOptions"
    [giftOptions]="giftOptions"
    (formSearch)="onSearch($event)"
    (formReset)="onReset()"
  >
    <div slot="actions">
      <app-status-filter
        [primaryButton]="primaryButton"
        [secondaryButton]="secondaryButton"
        (primaryButtonClick)="approveOrders()"
        (secondaryButtonClick)="rejectOrders()"
      >
      </app-status-filter>
    </div>
  </app-search-form>

  <!-- Status Filter with Action Buttons -->
  <div class="mb-2 flex-table-header">
    <app-status-filter
      [statusOptions]="statusOptions"
      (statusChange)="onStatusChange($event)"
    ></app-status-filter>
  </div>

  <!-- Data Table -->
  <div class="flex-table-section">
    <app-data-table
      data-testid="order-audit-table"
      [dataSource]="orders"
      [columns]="columns"
      [rows]="rows"
      [first]="first"
      [totalRecords]="totalRecords"
      [loading]="loading"
      scrollHeight="flex"
      (pageChange)="onPageChange($event)"
    >
    </app-data-table>
  </div>
</div>
